import styled from 'styled-components';

import Popup, { PopupUpgradeHeader } from '../PopupOverlay';
import { useApp } from '../../../contexts/AppContext';
import { isLuckEvent } from '../../../lib/events';
import { getQuote } from '../../../lib/farming/quotes';
import RunningText from '../../RunningText';
import MeerkatHeadAnimated from '../../Icons/MeerkatHeadAnimated';
import { IconCup } from '../../../components/Icons/IconCup';
import { useTranslation } from 'react-i18next';

export const ContainerAnimation = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 800px;
  margin-top: 40px;
  margin-bottom: 40px;

  @keyframes pulseAnimation {
    0% {
      transform: scale(0.95);
    }

    50% {
      transform: scale(1);
    }

    100% {
      transform: scale(0.95);
    }
  }

  > svg {
    height: auto;
    position: absolute;
    top: 200px;
    left: 100px;
    width: 120px;
    z-index: 100;

    animation: pulseAnimation 2s infinite;

    &:first-of-type {
      width: 250px;
      left: 100px;
      top: 610px;
    }

    &:nth-of-type(3) {
      width: 200px;
      left: 660px;
      top: 450px;
    }
  }
`;

const Cloud = () => {
  const { event } = useApp();
  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.language;

  if (!isLuckEvent(event)) throw new Error('Should not happen');

  const quote = getQuote('luck', currentLanguage);

  return (
    <Popup hideClose buttonText="Close" onConfirm={async () => {}}>
      <PopupUpgradeHeader>{t('boosts.upgrade')}!</PopupUpgradeHeader>
      <ContainerAnimation>
        <IconCup />
        <IconCup />
        <IconCup />
        <MeerkatHeadAnimated />
      </ContainerAnimation>
      <RunningText text={quote} />
    </Popup>
  );
};

export default Cloud;
